import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getEscalaCobrancaPromotor, getReservaStatusOptions } from "../../services/motorService";

const FORMA_PAGAMENTO_OPTIONS = ["Cartão", "Depósito", "Outro"];

const MotorFilterModal = ({ open, onClose, setIsFilter, changeFilter, params, resetFilters }) => {
  const [statusMotorOptions, setStatusMotorOptions] = useState([]);
  const [promotoresOptions, setPromotoresOptions] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      const statusOptions = await getReservaStatusOptions();
      const promotores = await getEscalaCobrancaPromotor();

      setStatusMotorOptions(Array.isArray(statusOptions) ? statusOptions : []);
      setPromotoresOptions(Array.isArray(promotores) ? promotores : []);
    };
    fetchOptions();
  }, []);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{ width: "30%", margin: "auto", overflow: "scroll" }}
    >
      <Card>
        <CardHeader title={"Filtros avançados"} />
        <Divider />
        <CardContent style={{ display: "flex", flexDirection: "column" }}>
          <FormControl sx={{ m: 1 }}>
            <TextField
              label="Nº Reserva"
              value={params.numreserva}
              onChange={(e) => changeFilter("numreserva", e.target.value)}
            />
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <TextField
              label="Cód. Referência"
              value={params.codreferencia}
              onChange={(e) => changeFilter("codreferencia", e.target.value)}
            />
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <TextField
              label="Status Reserva (PMS)"
              value={params.status_reserva}
              onChange={(e) => changeFilter("status_reserva", e.target.value)}
            />
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <TextField
              label="Tipo de Reserva"
              value={params.tipo_reserva}
              onChange={(e) => changeFilter("tipo_reserva", e.target.value)}
            />
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <InputLabel id="forma-pagamento-label">Forma de Pagamento</InputLabel>
            <Select
              labelId="forma-pagamento-label"
              label="Forma de Pagamento"
              value={params.forma_pagamento || ""}
              onChange={(e) => changeFilter("forma_pagamento", e.target.value)}
              sx={{ fontFamily: "Montserrat" }}
            >
              <MenuItem value="" sx={{ fontFamily: "Montserrat", fontWeight: 600 }}>
                Todas
              </MenuItem>
              {FORMA_PAGAMENTO_OPTIONS.map((option) => (
                <MenuItem key={option} value={option} sx={{ fontFamily: "Montserrat" }}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <InputLabel id="promotor-label">Promotor</InputLabel>
            <Select
              labelId="promotor-label"
              label="Promotor"
              value={params.nome_promotor || ""}
              onChange={(e) => changeFilter("nome_promotor", e.target.value)}
              sx={{ fontFamily: "Montserrat" }}
            >
              <MenuItem value="" sx={{ fontFamily: "Montserrat", fontWeight: 600 }}>
                Todos
              </MenuItem>
              {promotoresOptions.map((option) => (
                <MenuItem
                  key={option.id_promotor}
                  value={option.nome_promotor}
                  sx={{ fontFamily: "Montserrat" }}
                >
                  {option.nome_promotor}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <TextField
              label="Motivo Cancelamento"
              value={params.motivo_cancelamento}
              onChange={(e) => changeFilter("motivo_cancelamento", e.target.value)}
            />
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <InputLabel id="status-motor-label">Status Motor</InputLabel>
            <Select
              labelId="status-motor-label"
              label="Status Motor"
              value={params.status || ""}
              onChange={(e) => changeFilter("status", e.target.value)}
              sx={{ fontFamily: "Montserrat" }}
            >
              <MenuItem value="" sx={{ fontFamily: "Montserrat", fontWeight: 600 }}>
                Todos
              </MenuItem>
              {statusMotorOptions.map((option) => (
                <MenuItem
                  key={option.id_status}
                  value={option.ds_status}
                  sx={{ fontFamily: "Montserrat" }}
                >
                  {option.ds_status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <TextField
              label="Observação"
              value={params.observacao}
              onChange={(e) => changeFilter("observacao", e.target.value)}
            />
          </FormControl>

          <Button
            sx={{ m: 1, color: "#fff", fontWeight: 700, textTransform: "capitalize" }}
            onClick={setIsFilter}
            color="tertiary"
            variant="contained"
          >
            Filtrar Listagem
          </Button>

          <Button
            sx={{ m: 1, fontWeight: 700, textTransform: "capitalize" }}
            onClick={resetFilters}
            color="secondary"
            variant="outlined"
          >
            Limpar Filtros
          </Button>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default MotorFilterModal;
